import { answerContentSchema } from "@/schema/console/evaluation-reports/AnswerContent";
import { z } from "zod";

export const answerSubCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  is_checked: z.number(),
  answer_contents: z.array(answerContentSchema),
});

export type AnswerSubCategory = z.infer<typeof answerSubCategorySchema>;
